import Vue from 'vue'
import VueRouter from 'vue-router'
import {  getNavList ,getFriendshipLinks} from '@/api/home'
import { setPermRoutes , routeStore , setFriendshipLinks } from '@/store'
import { routeHistory } from './history'

function getRoutes() {
  return routeStore.permRoutes || []
}

function getLinks(){
  return routeStore.friendshipLinks || []
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home' // 默认跳转到首页
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/index.vue'),
    meta: {
      title: '首页-池州市第三人民医院'
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test.vue'),
    meta: {
      title: '测试'
    }
  },
  {
    path: '/hospital-intro',
    name: 'hospitalIntro',
    component: () => import('@/views/hospital-intro/index.vue'),
    meta: {
      title: '医院概况-池州市第三人民医院',
      id: 200,
      noScroll: true
    }
  },

  {
    path: '/medical-guide',
    name: 'medicalGuide',
    component: () => import('@/views/medical-guide/index.vue'),
    meta: {
      title: '就医指南-池州市第三人民医院',
      id:201,
      noScroll: true
    }
  },
  {
    path: '/party-building',
    name: 'partyBuilding',
    component: () => import('@/views/party-building/index.vue'),
    meta: {
      title: '党群建设-池州市第三人民医院',
      id:202,
      noScroll: true
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/index.vue'),
    meta: {
      title: '新闻中心-池州市第三人民医院',
      id:203,
      noScroll: true
    }
  },
  {
    path: '/notices',
    name: 'notices',
    component: () => import('@/views/notices/index.vue'),
    meta: {
      title: '通知公告-池州市第三人民医院',
      id:204,
      noScroll: true
    }
  },
  {
    path: '/special-topics',
    name: 'specialTopics',
    component: () => import('@/views/special-topics/index.vue'),
    meta: {
      title: '专题专栏-池州市第三人民医院',
      id:205,
      noScroll: true
    }
  },
  {
    path: '/info-disclosure',
    name: 'infoDisclosure',
    component: () => import('@/views/info-disclosure/index.vue'),
    meta: {
      title: '信息公开-池州市第三人民医院',
      id:206,
      noScroll: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/search/index.vue'),
    meta: {
      title: '信息搜索-池州市第三人民医院',
      noScroll: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 页面跳转时滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 确保 body 的 overflow 样式被重置，防止滚动被锁定
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = ''
    }

    if (to.meta && to.meta.noScroll && to.name === from.name) {

        return false

    }


    // 如果有保存的位置（比如浏览器前进/后退），则返回到保存的位置
    if (savedPosition) {
      return new Promise((resolve) => {
        Vue.nextTick(() => {
          resolve(savedPosition)
        })
      })
    } else {
      // 否则滚动到顶部，使用 Promise 确保 DOM 更新完成后再滚动
      return new Promise((resolve) => {
        Vue.nextTick(() => {
          // 尝试多种方式滚动到顶部，确保兼容性
          if (window.scrollTo) {
            window.scrollTo(0, 0)
          } else if (window.pageYOffset !== undefined) {
            window.pageYOffset = 0
          }
          // 同时滚动 document.documentElement 和 document.body
          if (document.documentElement) {
            document.documentElement.scrollTop = 0
          }
          if (document.body) {
            document.body.scrollTop = 0
          }
          resolve({ x: 0, y: 0 })
        })
      })
    }
  }
})

// 防止重复请求的标记
let isNavListLoading = false
let navListPromise = null

// 路由守卫：设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title? to.meta.title : '池州市第三人民医院'

  if (from.name) {
    routeHistory.push(from)
  }

  const routes = getRoutes()
  if(routes.length ===  0) {
    // 如果正在加载，等待之前的请求完成
    if (isNavListLoading && navListPromise) {
      navListPromise.then(() => {
        next()
      }).catch(() => {
        next()
      })
      return
    }

    // 开始加载
    isNavListLoading = true
    navListPromise = getNavList().then(res => {
      const resData = res.data || []
      const newRoutes = resData.length > 0 ? resData[0].children : []
      setPermRoutes(newRoutes)
      getLinksData()
      isNavListLoading = false
      navListPromise = null
      next()
    }).catch(err => {
      console.error('加载导航列表失败:', err)
      isNavListLoading = false
      navListPromise = null
      next()
    })
  } else {
    next()
  }
})

// 捕获并忽略导航取消错误
const originalPush = router.push
const originalReplace = router.replace

router.push = function(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    // 忽略导航取消错误
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      return Promise.reject(err)
    }
  })
}

router.replace = function(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    // 忽略导航取消错误
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      return Promise.reject(err)
    }
  })
}


router.onError(error => {
  const chunkLoadFailed =
    error.name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/.test(error.message)

  if (chunkLoadFailed) {
    console.error('Chunk load failed, force reload:', error)
    window.location.reload()
  }
})

function getLinksData(){
  if(getLinks().length > 0) return
  getFriendshipLinks().then(res => {
    const resData = res.data || []
    const friendshipLinks = resData.filter(item => item.isVisible === 1)
    // 根据orderNum排序 ，1在前面
    friendshipLinks.sort((a, b) => a.orderNum - b.orderNum)
    setFriendshipLinks(friendshipLinks)
  })
}

export default router
